import { get, post, prefix } from './base'
// 获取验证码（商户端）
export function querySmsCode (params) {
    return get(prefix + 'querySmsCode', params)
}

//注册商户
export function register (params) {
    return post(prefix + 'register', params)
}

// n-token 换 x-token
export function companyLogin (params) {
    return get('/rest/passport/v1/login/companyLogin', params)
}

// 获取图片验证码
export function getVerificationCode (params) {
    return get('/rest/getVerificationCode', params)
}
